import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";

const Index = lazy(() => import("./pages/Index"));
const NotFound = lazy(() => import("./pages/NotFound"));
const PrivacyN8N = lazy(() => import("./pages/privacy-n8n"));
const AiTalks = lazy(() => import("./pages/ai-talks"));
const Books = lazy(() => import("./pages/books"));

const App = () => (
  <BrowserRouter>
    <Suspense fallback={<div className="min-h-screen bg-paper" />}>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/privacy-n8n" element={<PrivacyN8N />} />
        <Route path="/ai" element={<AiTalks />} />
        <Route path="/books" element={<Books />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  </BrowserRouter>
);

export default App;
